import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

type Props = {
  handleChange: (token: string | null) => void;
};
export default function Captcha({ handleChange }: Props) {
  return (
    <ReCAPTCHA
      sitekey="6LcJzuAZAAAAANi6DVT79jjORjP2CPVipB6S6FUq"
      onChange={handleChange}
    />
  );
}
